<template>
  <div>
    <main-header></main-header>
    <div class="page">
      <div class="w1200">
        <div class="shippint-toptitle">
          <div class="left">
            {{language[languagetype].yjxq}}
          </div>
          <div class="right" @click="backorder">
            {{language[languagetype].back}}
          </div>
        </div>
        <div class="goodspage-main">
          <div class="goodspage-main-zhutitle">
            {{language[languagetype].yjxq}}
          </div>
          <div class="goodspage-main-canshu">
            <div>
              <span>{{language[languagetype].waybill}}：{{detail.businessno}}</span>
              <span>{{language[languagetype].blno}}：{{detail.mblNo}}</span>
              <span>{{language[languagetype].company}}：{{detail.carriercode}}</span>
              <span>{{language[languagetype].vesselname}}：{{detail.vesselname}}</span>
              <span>{{language[languagetype].voyage}}：{{detail.voyno}}</span>
              <span>{{language[languagetype].receipt}}：{{detail.recplace}}</span>
              <span>{{language[languagetype].loadingport}}：{{detail.loadport}}</span>
              <span>{{language[languagetype].discharge}}：{{detail.dischargeport}}</span>
              <span>{{language[languagetype].delivery}}：{{detail.delplace}}</span>
            </div>
            <div>
              <span>{{language[languagetype].closing}}：{{formatDayTime(detail.etc)}}</span>
              <span>{{language[languagetype].closinga}}：{{formatDayTime(detail.wightTimeOfCut)}}</span>
              <span>{{language[languagetype].sailingtime}}：{{formatDayTime(detail.planetd)}}</span>
              <span>{{language[languagetype].wjxz}}：<a href="javascript:;" @click="xzlist">{{language[languagetype].xz}}</a></span>
            </div>
          </div>
          <div class="goodspage-main-title">
            {{language[languagetype].information}}
          </div>
          <div class="goodspage-main-table">
            <div class="goodspage-main-table-th">
              <div></div>
              <div>{{language[languagetype].casenumber}}</div>
              <div>{{language[languagetype].type}}</div>
              <div>{{language[languagetype].title}}</div>
              <div>{{language[languagetype].number}}</div>
              <div>{{language[languagetype].packing}}</div>
              <div>{{language[languagetype].weight}}</div>
              <div>{{language[languagetype].volume}}</div>
            </div>
            <div class="goodspage-main-table-td" v-for="(list,index) in detail.fmsContainers" :key="index">
              <div></div>
              <div>{{list.ctnno}}</div>
              <div>{{list.ctnSize}}{{list.ctnType}}</div>
              <div>{{list.sealno}}</div>
              <div>{{list.goodsCount}}</div>
              <div>{{list.packType}}</div>
              <div>{{list.goodsWeight}}</div>
              <div>{{list.goodsVolume}}</div>
            </div>
          </div>
          <div class="goodspage-main-zhutitle2">
            <div :class="boxshow ? 's' : ''" @click="change(1)">{{language[languagetype].boxdt}}</div>
            <div :class="!boxshow ? 's' : ''" @click="change(2)">{{language[languagetype].cbdt}}</div>
          </div>
          <div class="goodspage-main-box" v-if="boxshow">
            <div class="goodspage-main-box-left">
              <div class="goodspage-main-box-left-top">
                <div class="title">{{language[languagetype].casenumber}}</div>
                <div class="btn" @click="allbtn">{{language[languagetype].all}}</div>
              </div>
              <div class="goodspage-main-box-left-brand">
                <ul>
                  <li v-for="(list,index) in detail.fmsContainers" :key="index" :class="{s:index==clickid}" @click="clicks(index,list.ctnno)">{{list.ctnno}}</li>
                </ul>
              </div>
            </div>
            <div class="goodspage-main-box-right" v-if="boxrightshow">
              <ul class="goodspage-main-box-right-ul">
                <li>
                  <div class="name">{{language[languagetype].jgsj}}</div>
                  <div class="icon"></div>
                  <div class="time">{{getdata.datea}}</div>
                </li>
                <li>
                  <div class="name">{{language[languagetype].hgfxsj}}</div>
                  <div class="icon"></div>
                  <div class="time">{{getdata.dateb}}</div>
                </li>
                <li>
                  <div class="name">{{language[languagetype].mtfxsj}}</div>
                  <div class="icon"></div>
                  <div class="time">{{getdata.datec}}</div>
                </li>
                <li>
                  <div class="name">{{language[languagetype].qsgzcsj}}</div>
                  <div class="icon"></div>
                  <div class="time">{{getdata.dated}}</div>
                </li>
                <li>
                  <div class="name">{{language[languagetype].zzgzcsj}}</div>
                  <div class="icon"></div>
                  <div class="time">{{getdata.datee}}</div>
                </li>
                <li>
                  <div class="name">{{language[languagetype].zzgxcsj}}</div>
                  <div class="icon"></div>
                  <div class="time">{{getdata.datef}}</div>
                </li>
                <li>
                  <div class="name">{{language[languagetype].mdgxcsj}}</div>
                  <div class="icon"></div>
                  <div class="time">{{getdata.dateg}}</div>
                </li>
                <li>
                  <div class="name">{{language[languagetype].mdgtxsj}}</div>
                  <div class="icon"></div>
                  <div class="time">{{getdata.dateh}}</div>
                </li>
                <li>
                  <div class="name">{{language[languagetype].mdghksj}}</div>
                  <div class="icon"></div>
                  <div class="time">{{getdata.datei}}</div>
                </li>
              </ul>
            </div>
          </div>
          <div class="goodspage-main-dynamic" v-if="!boxshow">
            <div class="goodspage-main-dynamic-left"></div>
            <div class="goodspage-main-dynamic-right">
              <ul class="goodspage-main-dynamic-right-ul">
                <li>
                  <div class="name">{{language[languagetype].qyg}}</div>
                  <div class="icon">:</div>
                  <div class="time">{{detail.loadport}}</div>
                </li>
                <li>
                  <div class="name">{{language[languagetype].yjlg}}</div>
                  <div class="iconfirst"></div>
                  <div class="time" v-if="detail.shipDataItem!=undefined && detail.shipDataItem.etd!=undefined">{{formatDayTime(detail.shipDataItem.etd)}}</div>
                </li>
                <li>
                  <div class="name">{{language[languagetype].sjkh}}</div>
                  <div class="iconlast"></div>
                  <div class="time" v-if="detail.shipDataItem!=undefined && detail.shipDataItem.atd!=undefined">{{formatDayTime(detail.shipDataItem.atd)}}</div>
                </li>
                <li class="kong">
                  <div class="name"></div>
                  <div class="icon"></div>
                  <div class="time"></div>
                </li>
                <li>
                  <div class="name">{{language[languagetype].mdggk}}</div>
                  <div class="icon">:</div>
                  <div class="time">{{detail.dischargeport}}</div>
                </li>
                <li>
                  <div class="name">{{language[languagetype].yjdg}}</div>
                  <div class="iconfirst"></div>
                  <div class="time" v-if="detail.shipDataItem!=undefined && detail.shipDataItem.dest_etd!=undefined">{{formatDayTime(detail.shipDataItem.dest_etd)}}</div>
                </li>
                <li>
                  <div class="name">{{language[languagetype].sjdg}}</div>
                  <div class="iconlast"></div>
                  <div class="time" v-if="detail.shipDataItem!=undefined && detail.shipDataItem.dest_atd!=undefined">{{formatDayTime(detail.shipDataItem.dest_atd)}}</div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="wrapbg" v-if="warpshow">
      <div class="wrap">
        <div class="wrap-top">
          <div class="inputbox">
            <span>{{language[languagetype].boxdt}}</span>
            <input type="text" :placeholder="language[languagetype].plea" v-model="boxnum">
            <div class="btn" @click="findbox">{{language[languagetype].all}}</div>
          </div>
          <div class="closebtn" @click="warpclose"></div>
        </div>
        <div class="order-main-table">
          <div class="order-main-table-th">
            <div></div>
            <div>{{language[languagetype].casenumber}}</div>
            <div>{{language[languagetype].txsj}}</div>
            <div>{{language[languagetype].rksj}}</div>
            <div>{{language[languagetype].dcsj}}</div>
            <div>{{language[languagetype].lcsj}}</div>
            <div>{{language[languagetype].hgcysj}}</div>
            <div>{{language[languagetype].hgfxsj}}</div>
            <div>{{language[languagetype].mtfxsj}}</div>
            <div>{{language[languagetype].zcsj}}</div>
            <div>{{language[languagetype].xcsj}}</div>
            <div>{{language[languagetype].zxccsj}}</div>
            <div>{{language[languagetype].hxsj}}</div>
          </div>
          <ul class="order-main-tabletdlist">
            <li class="order-main-table-td" v-for="boxarr in boxarrs" :key="boxarr.dataa">
              <div></div>
              <div>{{boxarr.datea}}</div>
              <div>{{boxarr.dateb}}</div>
              <div>{{boxarr.datec}}</div>
              <div>{{boxarr.dated}}</div>
              <div>{{boxarr.datee}}</div>
              <div>{{boxarr.datef}}</div>
              <div>{{boxarr.dateg}}</div>
              <div>{{boxarr.dateh}}</div>
              <div>{{boxarr.datei}}</div>
              <div>{{boxarr.datej}}</div>
              <div>{{boxarr.datek}}</div>
              <div>{{boxarr.datel}}</div>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <toast ref="toasttext"></toast>
  </div>
</template>

<script>
import MainHeader from './header'
import toast from '../components/taast/toast'
import httppost from '../js/ajax'
let languagetext = require('../js/goodspage.json')
export default {
  name: 'about',
  data () {
    return {
      detail: {
        businessno: '',
        casenumber: '',
        carrier: '',
        vesselname: '',
        voyno: '',
        delplace: '',
        loadport: '',
        dischargeport: '',
        etc: '',
        wightTimeOfCut: '',
        planetd: '',
        fmsContainers: [],
        shipDataItem: {
          etd: '',
          eta: '',
          atd: '',
          ata: '',
          dest_etd: '',
          dest_atd: ''
        }
      },
      brandindex: 0,
      dataa: {
      },
      language: {},
      languagetype: 'cn',
      boxshow: true,
      warpshow: false,
      pageindexarr: [],
      clickid: '',
      isdingyue: '',
      boxrightshow: false,
      boxnum: '',
      getdata: {
        datea: '',
        dateb: '',
        datec: '',
        dated: '',
        datee: '',
        datef: '',
        dateg: '',
        dateh: '',
        datei: ''
      },
      finddata: {
        datea: '',
        dateb: '',
        datec: '',
        dated: '',
        datee: '',
        datef: '',
        dateg: '',
        dateh: '',
        datei: '',
        datej: '',
        datek: '',
        datel: ''
      },
      allboxcontent: [],
      boxarrs: [],
      findcontent: []
    }
  },
  methods: {
    backorder: function () {
      this.$router.back(-1)
    },
    goodspageleft: function () {
      if (this.brandindex - 1 <= 0) {
        this.brandindex = 0
      } else {
        this.brandindex = this.brandindex - 1
      }
    },
    allbtn: function () {
      this.warpshow = true
    },
    warpclose: function () {
      this.boxarrs = this.allboxcontent
      this.warpshow = false
    },
    goodspageright: function () {
      if (this.brandindex + 1 > 6) {
        this.brandindex = 6
      } else {
        this.brandindex = this.brandindex + 1
      }
    },
    change: function (data) {
      const that = this
      if (data === 1) {
        that.boxshow = true
      } else {
        that.boxshow = false
      }
    },
    formatDayTime: function (val) {
      if (val) {
        let date = new Date(val)
        let Y = date.getFullYear()
        let M = date.getMonth() + 1
        let D = date.getDate()

        if (M < 10) {
          M = '0' + M
        }
        if (D < 10) {
          D = '0' + D
        }
        return Y + '.' + M + '.' + D
      } else {
        return ''
      }
    },
    findbox: function () {
      const that = this
      that.findcontent = []
      if (that.isdingyue === undefined || that.isdingyue === '') {
        that.$refs.toasttext.show(that.language[that.languagetype].nodatadingyue)
      } else {
        that.boxrightshow = true
        httppost.post('Api/http', {
          name: 'portal.visualization.container.query',
          subscribeUuid: that.isdingyue,
          ctnno: that.boxnum
        }).then((res) => {
          if (res.code === '0') {
            if (res.data.ctnInfo.length > 0) {
              for (var j = 0; j < res.data.ctnInfo.length; j++) {
                var newdatali = {}
                newdatali.datea = res.data.ctnInfo[j].ctnNo
                for (var k = 0; k < res.data.ctnInfo[j].nodeList.length; k++) {
                  if (res.data.ctnInfo[j].nodeList[k].statusCode === 'STSP') {
                    newdatali.dateb = res.data.ctnInfo[j].nodeList[k].statusTime
                  }
                  if (res.data.ctnInfo[j].nodeList[k].statusCode === 'STSP') {
                    newdatali.datec = res.data.ctnInfo[j].nodeList[k].statusTime
                  }
                  if (res.data.ctnInfo[j].nodeList[k].statusCode === 'LOBD') {
                    newdatali.dated = res.data.ctnInfo[j].nodeList[k].statusTime
                  }
                  if (res.data.ctnInfo[j].nodeList[k].statusCode === 'GITM') {
                    newdatali.datee = res.data.ctnInfo[j].nodeList[k].statusTime
                  }
                  if (res.data.ctnInfo[j].nodeList[k].statusCode === 'PLPS') {
                    newdatali.dateg = res.data.ctnInfo[j].nodeList[k].statusTime
                  }
                  if (res.data.ctnInfo[j].nodeList[k].statusCode === 'TMPS') {
                    newdatali.dateh = res.data.ctnInfo[j].nodeList[k].statusTime
                  }
                  if (res.data.ctnInfo[j].nodeList[k].statusCode === 'LOBD') {
                    newdatali.datei = res.data.ctnInfo[j].nodeList[k].statusTime
                  }
                  if (res.data.ctnInfo[j].nodeList[k].statusCode === 'DSCH') {
                    newdatali.datej = res.data.ctnInfo[j].nodeList[k].statusTime
                  }
                  if (res.data.ctnInfo[j].nodeList[k].statusCode === 'STCS') {
                    newdatali.datek = res.data.ctnInfo[j].nodeList[k].statusTime
                  }
                  if (res.data.ctnInfo[j].nodeList[k].statusCode === 'RCVE') {
                    newdatali.datel = res.data.ctnInfo[j].nodeList[k].statusTime
                  }
                }
                that.findcontent.push(newdatali)
              }
              that.boxarrs = that.findcontent
            } else {
              that.$refs.toasttext.show(that.language[that.languagetype].nodata)
              that.boxarrs = []
            }
          } else {
            that.$refs.toasttext.show(res.msg)
          }
        }).catch(err => {
          that.$refs.toasttext.show(err.msg)
        })
      }
    },
    xzlist: function () {
      const that = this
      this.$router.push({name: 'gooddown', params: { id: that.$route.params.number }})
    },
    clicks: function (index, btno) {
      const that = this
      that.clickid = index
      if (that.isdingyue === undefined || that.isdingyue === '') {
        that.$refs.toasttext.show(that.language[that.languagetype].nodatadingyue)
      } else {
        that.boxrightshow = true
        httppost.post('Api/http', {
          name: 'portal.visualization.container.query',
          subscribeUuid: that.isdingyue,
          ctnno: btno
        }).then((res) => {
          if (res.code === '0') {
            for (var i = 0; i < res.data.ctnInfo[0].nodeList.length; i++) {
              if (res.data.ctnInfo[0].nodeList[i].statusCode === 'GITM') {
                that.getdata.datea = res.data.ctnInfo[0].nodeList[i].statusTime
              }
              if (res.data.ctnInfo[0].nodeList[i].statusCode === 'PLPS') {
                that.getdata.dateb = res.data.ctnInfo[0].nodeList[i].statusTime
              }
              if (res.data.ctnInfo[0].nodeList[i].statusCode === 'TMPS') {
                that.getdata.datec = res.data.ctnInfo[0].nodeList[i].statusTime
              }
              if (res.data.ctnInfo[0].nodeList[i].statusCode === 'LOBD') {
                that.getdata.dated = res.data.ctnInfo[0].nodeList[i].statusTime
              }
              if (res.data.ctnInfo[0].nodeList[i].statusCode === 'TSLB') {
                that.getdata.datee = res.data.ctnInfo[0].nodeList[i].statusTime
              }
              if (res.data.ctnInfo[0].nodeList[i].statusCode === 'TSDC') {
                that.getdata.datef = res.data.ctnInfo[0].nodeList[i].statusTime
              }
              if (res.data.ctnInfo[0].nodeList[i].statusCode === 'DSCH') {
                that.getdata.dateg = res.data.ctnInfo[0].nodeList[i].statusTime
              }
              if (res.data.ctnInfo[0].nodeList[i].statusCode === 'STCS') {
                that.getdata.dateh = res.data.ctnInfo[0].nodeList[i].statusTime
              }
              if (res.data.ctnInfo[0].nodeList[i].statusCode === 'RCVE') {
                that.getdata.datei = res.data.ctnInfo[0].nodeList[i].statusTime
              }
            }
          } else {
            that.$refs.toasttext.show(res.msg)
          }
        }).catch(err => {
          that.$refs.toasttext.show(err.msg)
        })
      }
    }
  },
  components: {
    MainHeader,
    toast
  },
  created () {
    const that = this
    that.language = languagetext
    that.lang = sessionStorage.getItem('lang') || 1
    // eslint-disable-next-line
    if (that.lang != 1) {
      that.languagetype = 'en'
    }
    that.username = JSON.parse(localStorage.getItem('username'))
    if (that.username == null) {
      setTimeout(function () {
        that.$refs.toasttext.show(that.language[that.languagetype].islogin)
      }, 300)
      setTimeout(function () {
        that.$router.push({name: 'login'})
      }, 1000)
    } else {
      httppost.post('Api/http', {
        name: 'portal.sea.orderDetail.query',
        customerName: that.username.customerName,
        casenumber: that.$route.params.number
      }).then((res) => {
        if (res.code === '0') {
          that.detail = res.data.fmsExternalOrderDetailList[0]
          that.isdingyue = res.data.fmsExternalOrderDetailList[0].subscribeUuid
          if (that.isdingyue === undefined || that.isdingyue === '') {
            that.$refs.toasttext.show(that.language[that.languagetype].nodatadingyue)
          } else {
            that.boxrightshow = true
            httppost.post('Api/http', {
              name: 'portal.visualization.container.query',
              subscribeUuid: that.isdingyue,
              ctnno: ''
            }).then((res) => {
              if (res.code === '0') {
                if (res.data.ctnInfo.length > 0) {
                  for (var j = 0; j < res.data.ctnInfo.length; j++) {
                    var newdatali = {}
                    newdatali.datea = res.data.ctnInfo[j].ctnNo
                    for (var k = 0; k < res.data.ctnInfo[j].nodeList.length; k++) {
                      if (res.data.ctnInfo[j].nodeList[k].statusCode === 'STSP') {
                        newdatali.dateb = res.data.ctnInfo[j].nodeList[k].statusTime
                      }
                      if (res.data.ctnInfo[j].nodeList[k].statusCode === 'STSP') {
                        newdatali.datec = res.data.ctnInfo[j].nodeList[k].statusTime
                      }
                      if (res.data.ctnInfo[j].nodeList[k].statusCode === 'LOBD') {
                        newdatali.dated = res.data.ctnInfo[j].nodeList[k].statusTime
                      }
                      if (res.data.ctnInfo[j].nodeList[k].statusCode === 'GITM') {
                        newdatali.datee = res.data.ctnInfo[j].nodeList[k].statusTime
                      }
                      if (res.data.ctnInfo[j].nodeList[k].statusCode === 'PLPS') {
                        newdatali.dateg = res.data.ctnInfo[j].nodeList[k].statusTime
                      }
                      if (res.data.ctnInfo[j].nodeList[k].statusCode === 'TMPS') {
                        newdatali.dateh = res.data.ctnInfo[j].nodeList[k].statusTime
                      }
                      if (res.data.ctnInfo[j].nodeList[k].statusCode === 'LOBD') {
                        newdatali.datei = res.data.ctnInfo[j].nodeList[k].statusTime
                      }
                      if (res.data.ctnInfo[j].nodeList[k].statusCode === 'DSCH') {
                        newdatali.datej = res.data.ctnInfo[j].nodeList[k].statusTime
                      }
                      if (res.data.ctnInfo[j].nodeList[k].statusCode === 'STCS') {
                        newdatali.datek = res.data.ctnInfo[j].nodeList[k].statusTime
                      }
                      if (res.data.ctnInfo[j].nodeList[k].statusCode === 'RCVE') {
                        newdatali.datel = res.data.ctnInfo[j].nodeList[k].statusTime
                      }
                    }
                    that.allboxcontent.push(newdatali)
                  }
                  that.boxarrs = that.allboxcontent
                  for (var i = 0; i < res.data.ctnInfo[0].nodeList.length; i++) {
                    if (res.data.ctnInfo[0].nodeList[i].statusCode === 'GITM') {
                      that.getdata.datea = res.data.ctnInfo[0].nodeList[i].statusTime
                    }
                    if (res.data.ctnInfo[0].nodeList[i].statusCode === 'PLPS') {
                      that.getdata.dateb = res.data.ctnInfo[0].nodeList[i].statusTime
                    }
                    if (res.data.ctnInfo[0].nodeList[i].statusCode === 'TMPS') {
                      that.getdata.datec = res.data.ctnInfo[0].nodeList[i].statusTime
                    }
                    if (res.data.ctnInfo[0].nodeList[i].statusCode === 'LOBD') {
                      that.getdata.dated = res.data.ctnInfo[0].nodeList[i].statusTime
                    }
                    if (res.data.ctnInfo[0].nodeList[i].statusCode === 'TSLB') {
                      that.getdata.datee = res.data.ctnInfo[0].nodeList[i].statusTime
                    }
                    if (res.data.ctnInfo[0].nodeList[i].statusCode === 'TSDC') {
                      that.getdata.datef = res.data.ctnInfo[0].nodeList[i].statusTime
                    }
                    if (res.data.ctnInfo[0].nodeList[i].statusCode === 'DSCH') {
                      that.getdata.dateg = res.data.ctnInfo[0].nodeList[i].statusTime
                    }
                    if (res.data.ctnInfo[0].nodeList[i].statusCode === 'STCS') {
                      that.getdata.dateh = res.data.ctnInfo[0].nodeList[i].statusTime
                    }
                    if (res.data.ctnInfo[0].nodeList[i].statusCode === 'RCVE') {
                      that.getdata.datei = res.data.ctnInfo[0].nodeList[i].statusTime
                    }
                  }
                } else {
                  that.$refs.toasttext.show(that.language[that.languagetype].nodata)
                }
              } else {
                that.$refs.toasttext.show(res.msg)
              }
            }).catch(err => {
              that.$refs.toasttext.show(err.msg)
            })
          }
        } else {
          that.$refs.toasttext.show(res.msg)
        }
      }).catch(err => {
        that.$refs.toasttext.show(err.msg)
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .page{min-height: 400px;background-color: #f6f6f6;}
  .shippint-toptitle{height: 92px;padding-top: 9px;display: flex;justify-content: space-between;}
  .shippint-toptitle .left{line-height: 92px;color: #333;font-size: 30px;}
  .shippint-toptitle .right{color: #999;font-size: 16px;line-height: 92px;cursor: pointer;background:url("../assets/backbtn.png") 0 center no-repeat;padding-left: 27px;}
  .goodspage-brand{width: 100%;height: 220px;overflow: hidden;position: relative;margin-top: 21px;}
  .goodspage-main{width: 100%;height: auto;overflow: hidden;background-color: #fff;box-sizing: border-box;padding: 0 30px 20px 30px;margin-top: 20px;}
  .goodspage-main-zhutitle{width: 100%;height: 50px;line-height: 50px;border-bottom: 1px solid #c5c5c5;font-size: 18px;}
  .goodspage-main-title{width: 100%;height: 28px;margin-top: 21px;font-size: 18px;}
  .goodspage-main-canshu{width:100%;height: auto;overflow: hidden;margin-top: 21px;}
  .goodspage-main-canshu div{width: 477px;height: auto;float: left;overflow: hidden;}
  .goodspage-main-canshu span{display: block;line-height: 33px;width: 275px;margin-right: 156px;}
  .goodspage-main-canshu a{padding-left: 23px;background:url("../assets/heise_x_z.png") 0 center no-repeat;display: inline-block;}
  .goodspage-main-table{width: 100%;height: auto;margin-top: 25px;box-sizing: border-box;}
  .goodspage-main-table-th{width: 100%;height: 50px;overflow: hidden;display: flex;background-color: #f6f6f6;}
  .goodspage-main-table-th div{flex-shrink: 0;height: 50px;font-weight: bold;line-height: 50px;}
  .goodspage-main-table-th div:nth-child(1){width: 23px;}
  .goodspage-main-table-th div:nth-child(2){width: 151px;}
  .goodspage-main-table-th div:nth-child(3){width: 114px;}
  .goodspage-main-table-th div:nth-child(4){width: 123px;}
  .goodspage-main-table-th div:nth-child(5){width: 129px;}
  .goodspage-main-table-th div:nth-child(6){width: 123px;}
  .goodspage-main-table-th div:nth-child(7){width: 135px;}
  .goodspage-main-table-th div:nth-child(8){width: 172px;}
  .goodspage-main-table-th div:nth-child(9){width: 170px;}
  .goodspage-main-table-td{width: 100%;height: 42px;margin-bottom:10px;display: flex;border-bottom: 1px dotted #c5c5c5;}
  .goodspage-main-table-td div{flex-shrink: 0;height: 42px;color: #999999;font-size: 12px;line-height: 42px;}
  .goodspage-main-table-td div:nth-child(1){width: 23px;}
  .goodspage-main-table-td div:nth-child(2){width: 151px;}
  .goodspage-main-table-td div:nth-child(3){width: 114px;}
  .goodspage-main-table-td div:nth-child(4){width: 123px;}
  .goodspage-main-table-td div:nth-child(5){width: 129px;}
  .goodspage-main-table-td div:nth-child(6){width: 123px;}
  .goodspage-main-table-td div:nth-child(7){width: 135px;}
  .goodspage-main-table-td div:nth-child(8){width: 172px;}
  .goodspage-main-table-td div:nth-child(9){width: 170px;}
  .goodspage-main-zhutitle2{width: 100%;height: 50px;line-height: 50px;position: relative;display: flex;}
  .goodspage-main-zhutitle2::after{content: "";width: 100%;height: 1px;position: absolute;bottom: 0;left: 0;background-color: #dfdfdf;}
  .goodspage-main-zhutitle2 div{font-size: 18px;line-height: 48px;margin-right: 60px;cursor: pointer;}
  .goodspage-main-zhutitle2 .s{border-bottom: 2px solid #2562ef;font-weight: bold;color: #2562ef;}
  .goodspage-main-box{width: 100%;height: 640px;display: flex;justify-content: space-between;}
  .goodspage-main-box-left{width: 190px;height: 100%;flex-shrink: 0;border-right: 1px solid #dfdfdf;}
  .goodspage-main-box-left-top{width: 100%;height: 38px;margin-top: 11px;display: flex;justify-content: space-between;align-items: center;box-sizing: border-box;padding-right: 24px;}
  .goodspage-main-box-left-top .title{font-size: 16px;font-weight: bold;}
  .goodspage-main-box-left-top .btn{font-size: 16px;color: #999999;text-decoration: underline;cursor:pointer;}
  .goodspage-main-box-left-brand{width: 100%;height: 570px;overflow-y:auto;
  /* scrollbar-width: none;-ms-overflow-style: none; */
  }
  .goodspage-main-box-left ul{width: 100%;height:auto;}
  /* .goodspage-main-box-left-brand::-webkit-scrollbar{display: none;} */
  .goodspage-main-box-left ul li{width: 100%;height: 40px;line-height: 40px;text-indent: 17px;background:url("../assets/boxicon.png") 0 center no-repeat;font-size: 16px;cursor: pointer;}
  .goodspage-main-box-left ul .s{color: #2562ef;}
  .goodspage-main-box-right{flex: 1;}
  .goodspage-main-box-right-ul{width: 100%;height: auto;overflow: hidden;}
  .goodspage-main-box-right-ul li{width: 100%;height: 54px;overflow: hidden;}
  .goodspage-main-box-right-ul li .name{float: left;width: 233px;text-align: right;font-size: 16px;line-height: 54px;height: 54px;}
  .goodspage-main-box-right-ul li .icon{width: 39px;height: 54px;background:url("../assets/boxrighticon2.png") center 0 no-repeat;float: left;}
  .goodspage-main-box-right-ul li .time{float: left;width: 233px;text-align: left;font-size: 16px;line-height: 54px;height: 54px;float: left;}
  .goodspage-main-box-right-ul li:nth-child(1) .icon{background:url("../assets/boxrighticon1.png") center 0 no-repeat;}
  .goodspage-main-box-right-ul li:nth-last-child(1) .icon{background:url("../assets/boxrighticon3.png") center 0 no-repeat;}
  .goodspage-main-dynamic{width: 100%;height: 640px;display: flex;justify-content: space-between;box-sizing: border-box;padding-top: 23px;}
  .goodspage-main-dynamic-left{width: 568px;height: 587px;background:url("../assets/dynamic.jpg") 0 0 no-repeat;display: none;}
  .goodspage-main-dynamic-right{flex: 1;height: 640px;}
  .goodspage-main-dynamic-right-ul{width: 100%;height: auto;overflow: hidden;}
  .goodspage-main-dynamic-right-ul li{width: 100%;height: 54px;overflow: hidden;}
  .goodspage-main-dynamic-right-ul li .name{float: left;width: 182px;text-align: right;font-size: 16px;line-height: 54px;height: 54px;}
  .goodspage-main-dynamic-right-ul li .icon{width: 39px;height: 54px;float: left;line-height: 54px;text-align: center;}
  .goodspage-main-dynamic-right-ul li .iconfirst{width: 39px;height: 54px;background:url("../assets/boxrighticon1.png") center 0 no-repeat;float: left;}
  .goodspage-main-dynamic-right-ul li .iconlast{width: 39px;height: 54px;background:url("../assets/boxrighticon3.png") center 0 no-repeat;float: left;}
  .goodspage-main-dynamic-right-ul li .icona{background:url("../assets/boxrighticon2.png") center 0 no-repeat;}
  .goodspage-main-dynamic-right-ul li .time{float: left;width: 182px;text-align: left;font-size: 16px;line-height: 54px;height: 54px;}
  .wrapbg{width: 100%;height: 100%;position: fixed;background-color: rgba(0, 0, 0, 0.4);left: 0;top: 0;z-index: 10;}
  .wrap{height: 580px;width: 1200px;position: absolute;top: 50%;left: 50%;margin-left: -600px;margin-top: -290px;background-color: #fff;overflow: hidden;box-sizing: border-box;padding: 0 10px;}
  .wrap-top{width: 100%;height: 32px;margin-top: 23px;display: flex;justify-content: space-between;}
  .wrap-top .inputbox{height: 32px;display: flex;}
  .wrap-top .inputbox span{display: block;line-height: 32px;width: auto;margin-right:20px;font-size: 16px;font-weight: bold;}
  .wrap-top .inputbox input{width: 186px;height: 32px;border:none;outline:none;box-sizing: border-box;border: 1px solid #c5c5c5;color: #333;text-indent: 4px}
  .wrap-top .inputbox input::placeholder{color: #999;}
  .wrap-top .inputbox .btn{width: 110px;height: 32px;border-radius: 2px;background-color: #336bed;height: 32px;line-height: 32px;text-align: center;color: #fff;margin-left: 5px;cursor: pointer;}
  .closebtn{width: 30px;height: 30px;background:url("../assets/close.png") center center no-repeat;cursor: pointer;}
  .order-main-table{width: 100%;height: auto;box-sizing: border-box;margin-top: 17px;padding-bottom: 15px;overflow-x: scroll;}
  .order-main-table-th{height: 50px;display: flex;background-color: #f6f6f6;width: 1520px;}
  .order-main-table-th div{flex-shrink: 0;height: 50px;font-weight: bold;line-height: 50px;overflow: hidden;text-overflow:ellipsis; white-space: nowrap;}
  .order-main-table-th div:nth-child(1){width: 23px;}
  .order-main-table-th div:nth-child(2){width: 122px;}
  .order-main-table-th div:nth-child(3){width: 125px;}
  .order-main-table-th div:nth-child(4){width: 125px;}
  .order-main-table-th div:nth-child(5){width: 125px;}
  .order-main-table-th div:nth-child(6){width: 125px;}
  .order-main-table-th div:nth-child(7){width: 125px;}
  .order-main-table-th div:nth-child(8){width: 125px;}
  .order-main-table-th div:nth-child(9){width: 125px;}
  .order-main-table-th div:nth-child(10){width: 125px;}
  .order-main-table-th div:nth-child(11){width: 125px;}
  .order-main-table-th div:nth-child(12){width: 125px;}
  .order-main-table-th div:nth-child(13){width: 125px;}
  .order-main-tabletdlist{width: 1520px;height: 420px;overflow: hidden;}
  .order-main-tabletdlist li{width: 100%;height: auto;overflow: hidden;}
  .order-main-tabletdlist li:nth-child(even){background-color: #f6f6f6;}
  .order-main-table-td{width: 100%;height: auto;display: flex;}
  .order-main-table-td div{flex-shrink: 0;height: 65px;min-height: 65px;color: #999999;font-size: 12px;line-height: 65px;box-sizing: border-box;box-sizing: border-box;padding-right: 4px;overflow: hidden;text-overflow:ellipsis;white-space: nowrap;}
  .order-main-table-td div span{line-height: 35px;display: block;width: 100%;height: auto;}
  .order-main-table-td div a{color: #2D5CC8;}
  .order-main-table-td div:nth-child(1){width: 23px;}
  .order-main-table-td div:nth-child(2){width: 122px;}
  .order-main-table-td div:nth-child(3){width: 125px;}
  .order-main-table-td div:nth-child(4){width: 125px;}
  .order-main-table-td div:nth-child(5){width: 125px;}
  .order-main-table-td div:nth-child(6){width: 125px;}
  .order-main-table-td div:nth-child(7){width: 125px;}
  .order-main-table-td div:nth-child(8){width: 125px;}
  .order-main-table-td div:nth-child(9){width: 125px;}
  .order-main-table-td div:nth-child(10){width: 125px;}
  .order-main-table-td div:nth-child(11){width: 125px;}
  .order-main-table-td div:nth-child(12){width: 125px;}
  .order-main-table-td div:nth-child(13){width: 125px;}
  .newslist-pageindex{width: 100%;height: auto;overflow: hidden;text-align: center;margin-bottom: 5px;margin-top: 15px;}
  .newslist-pageindex a{display: inline-block;width: auto;height: 32px;background-color: #f2f2f2;color: #333333;font-size: 14px;line-height: 32px;min-width: 32px;box-sizing: border-box;padding: 0 5px; margin-left: 5px;margin-right: 5px;}
  .newslist-pageindex .active{background-color: #2a3c66;color:#fff}
  .newslist-pageindex a:hover{background-color: #2a3c66;color:#fff}
  </style>



// WEBPACK FOOTER //
// src/page/goodspage.vue